export default __webpack_public_path__ + "static/media/fossil1.1144acd7.png";